import MoocScreen from './containers/moocScreen'

export {default as MoocScreenLayout} from './components/moocScreenLayout'

export default MoocScreen
